<div >
  <div class="logo-wrapper">
    <a class="logo-link" href="/home">
      <img class="img-fluid for-light" src="assets/logo.png" alt="" />
    <!--Dark theme-->
    <img class="img-fluid for-dark" src="assets/logo.png" alt="" />
    </a>
    <div class="back-btn" (click)="sidebarToggle()">
      <i class="fa fa-angle-left"></i>
    </div>
    <div class="toggle-sidebar" (click)="sidebarToggle()">
      <i class="status_toggle middle sidebar-toggle" data-feather="align-left">
      </i>
    </div>
  </div>
  <div class="logo-icon-wrapper">
    <a href="/home">  
      <img class="img-fluid for-light" src="assets/logo.png" alt="" />
    <img class="img-fluid for-dark" src="assets/logo.png" alt=""/></a>
  </div>
  <nav class="sidebar-main" >
    <div
      class="left-arrow"
      id="left-arrow"
      [class.d-none]="leftArrowNone"
      (click)="scrollToLeft()"
    >
      <app-feather-icon [icon]="'arrow-left'"></app-feather-icon>
    </div>
    <div id="sidebar-menu" [ngStyle]="{ marginLeft: margin + 'px' }">
      <ul class="sidebar-links custom-scrollbar" id="simple-bar">
        <li class="back-btn">
          <a href="/home"
            ><img
              class="img-fluid for-light"
              src="assets/images/logo/logo-icon.png"
              alt="" /><img
              class="img-fluid for-dark"
              src="assets/images/logo/logo-icon-dark.png"
              alt=""
          /></a>
          <div class="mobile-back text-end">
            <span>Back</span
            ><i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
          </div>
        </li>

        <li
          [class]="menuItem.headTitle1 ? 'sidebar-main-title' : 'sidebar-list'"
          *ngFor="let menuItem of menuItems"
          [ngClass]="{ active: menuItem.active }"
        >
          <div>
            <h4 class="lan-1">{{ menuItem.headTitle1 | translate }}</h4>
          </div>

          <a
            class="sidebar-link sidebar-title"
            href="javascript:void(0)"
            [class.link-nav]="!menuItem.children"
            [ngClass]="{ active: menuItem.active }"
            *ngIf="menuItem.type === 'sub'"
            (click)="toggletNavActive(menuItem)"
          >
            <app-feather-icon [icon]="menuItem.icon"></app-feather-icon>
            <span class="lan-5">{{ menuItem.title | translate }}</span
            ><span
              class="badge badge-primary"
              *ngIf="menuItem.badgeType && menuItem.badgeValue"
              >{{ menuItem.badgeValue }}</span
            >
            <div class="according-menu">
              <i
                class="fa fa-angle-{{
                  menuItem.active ? 'down' : 'right'
                }} pull-right"
                *ngIf="menuItem.children"
              ></i></div
          ></a>
            <!-- btn -->
            <a
            class="sidebar-link sidebar-title"
            (click)="menuItem.onClick()"
            routerLinkActive="active"
            [class.link-nav]="!menuItem.children"
            [ngClass]="{ active: menuItem.active }"
            *ngIf="menuItem.type === 'btn'"
          >
            <app-feather-icon [icon]="menuItem.icon"></app-feather-icon>
            <span class="lan-3" (click)="close()">{{
              menuItem.title | translate
            }}</span>

            <div class="according-menu">
              <i
                class="fa fa-angle-{{
                  menuItem.active ? 'down' : 'right'
                }} pull-right"
                *ngIf="menuItem.children"
              ></i></div
          ></a>
          <!-- link -->
          <a
            class="sidebar-link sidebar-title"
            [routerLink]="!menuItem.type ? null : [menuItem.path]"
            routerLinkActive="active"
            [class.link-nav]="!menuItem.children"
            [ngClass]="{ active: menuItem.active }"
            *ngIf="menuItem.type === 'link'"
          >
            <app-feather-icon [icon]="menuItem.icon"></app-feather-icon>
            <span class="lan-3" (click)="close()">{{
              menuItem.title | translate
            }}</span>

            <div class="according-menu">
              <i
                class="fa fa-angle-{{
                  menuItem.active ? 'down' : 'right'
                }} pull-right"
                *ngIf="menuItem.children"
              ></i></div
          ></a>
          <!-- external -->
          <a
            href="{{ !menuItem.type ? null : menuItem.path }}"
            class="sidebar-link sidebar-title"
            [class.link-nav]="!menuItem.children"
            [ngClass]="{ active: menuItem.active }"
            *ngIf="menuItem.type === 'extLink'"
          >
            <app-feather-icon [icon]="menuItem.icon"></app-feather-icon>
            <span class="lan-3">{{ menuItem.title | translate }}</span>

            <div class="according-menu">
              <i
                class="fa fa-angle-{{
                  menuItem.active ? 'down' : 'right'
                }} pull-right"
                *ngIf="menuItem.children"
              ></i></div
          ></a>
          <!-- external-tab-link -->
          <a
            href="{{ !menuItem.type ? null : menuItem.path }}"
            target="_blank"
            class="sidebar-link sidebar-title"
            [class.link-nav]="!menuItem.children"
            [ngClass]="{ active: menuItem.active }"
            *ngIf="menuItem.type === 'extTabLink'"
          >
            <app-feather-icon [icon]="menuItem.icon"></app-feather-icon>
            <span class="lan-3">{{ menuItem.title | translate }}</span>

            <div class="according-menu">
              <i
                class="fa fa-angle-{{
                  menuItem.active ? 'down' : 'right'
                }} pull-right"
                *ngIf="menuItem.children"
              ></i></div
          ></a>
          <!-- 2nd level -->
          <ul
            class="sidebar-submenu"
            [style.display]="menuItem.active ? 'block' : 'none'"
            [ngClass]="{ active: menuItem.active }"
            [ngClass]="{
              'menu-open': menuItem.active,
              'menu-close': !menuItem.active
            }"
            *ngIf="menuItem.children"
            [style.display]="menuItem.active ? 'block' : 'none'"
          >
            <li
              *ngFor="let childrenItem of menuItem.children"
              [ngClass]="{ active: childrenItem.active }"
            >
              <!-- sub -->
              <a
                class="submenu-title"
                href="javascript:void(0)"
                *ngIf="childrenItem.type === 'sub'"
                (click)="toggletNavActive(childrenItem)"
                >{{ childrenItem.title | translate
                }}<span class="sub-arrow">
                  <i
                    class="fa fa-angle-{{
                      childrenItem.active ? 'down' : 'right'
                    }} pull-right"
                    *ngIf="childrenItem.children"
                  ></i></span
              ></a>
              <!-- link -->
              <a
                [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
                *ngIf="childrenItem.type === 'link'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >{{ childrenItem.title | translate
                }}<span class="sub-arrow">
                  <i
                    class="fa fa-angle-down pull-right"
                    *ngIf="childrenItem.children"
                  ></i></span
              ></a>
              <!-- external-link -->
              <a
                class="submenu-title"
                href="{{ !childrenItem.type ? null : childrenItem.path }}"
                *ngIf="childrenItem.type === 'extLink'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >{{ childrenItem.title | translate
                }}<span class="sub-arrow">
                  <i
                    class="fa fa-angle-down pull-right"
                    *ngIf="childrenItem.children"
                  ></i></span
              ></a>
              <!-- external-tab-link -->
              <a
                class="submenu-title"
                href="{{ !childrenItem.type ? null : childrenItem.path }}"
                target="_blank"
                *ngIf="childrenItem.type === 'extTabLink'"
                >{{ childrenItem.title | translate
                }}<span class="sub-arrow">
                  <i
                    class="fa fa-angle-down pull-right"
                    *ngIf="childrenItem.children"
                  ></i></span
              ></a>
              <!-- 3rd level -->
              <ul
                class="nav-sub-childmenu submenu-content"
                *ngIf="childrenItem.children"
                [ngClass]="{ active: childrenItem.active }"
                [ngClass]="{
                  'menu-open': childrenItem.active,
                  'menu-close': !childrenItem.active
                }"
                [style.display]="childrenItem.active ? 'block' : 'none'"
              >
                <li
                  *ngFor="let childrenSubItem of childrenItem.children"
                  [ngClass]="{ active: childrenSubItem.active }"
                >
                  <a
                    [routerLink]="
                      !childrenSubItem.type ? null : [childrenSubItem.path]
                    "
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    *ngIf="childrenSubItem.type === 'link'"
                    >{{ childrenSubItem.title | translate }}
                  </a>
                  <!-- link -->
                  <!--   -->
                  <!-- external -->
                  <a
                    href="{{
                      !childrenSubItem.type ? null : childrenSubItem.path
                    }}"
                    *ngIf="childrenSubItem.type === 'extLink'"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><span>{{ childrenSubItem.title | translate }}</span></a
                  >

                  <!-- External Tab Link -->
                  <a
                    href="{{
                      !childrenSubItem.type ? null : childrenSubItem.path
                    }}"
                    target="_blank"
                    *ngIf="childrenSubItem.type === 'extTabLink'"
                  >
                    <span (click)="close()">{{
                      childrenSubItem.title | translate
                    }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div
      class="right-arrow"
      id="right-arrow"
      [class.d-none]="rightArrowNone"
      (click)="scrollToRight()"
    >
      <app-feather-icon [icon]="'arrow-right'"></app-feather-icon>
    </div>
  </nav>
</div>
